export default "__VITE_ASSET__CoLreA9d__"